import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const useChatOptionsStyles = makeStyles(() => ({
  list: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: '5px',
    marginRight: '5px',
    flexWrap: 'wrap'
  },
  option: {
    border: '1px solid #ECECEC',
    borderRadius: '16px',
    padding: '3px 10px',
    fontFamily: 'Open Sans, sans serif',
    fontSize: '16px',
    cursor: 'pointer',
    textTransform: 'none',
    alignSelf: 'flex-start',
    margin: 5,
    minWidth: 0
  },
  optionClicked: {
    border: '1px solid',
    borderRadius: '16px',
    color: '#9852EA',
    padding: '8px',
    fontFamily: 'Open Sans, sans serif',
    cursor: 'pointer',
    backgroundColor: '#dbc7ed',
    borderColor: '#9852EA'
  }
}))

function ChatOptionsPicker (props) {
  const options = props.options
  const chooseValue = props.chooseValue
  const conversation_event = props.conversation_event
  const promptsToClosedPromptEvents = props.promptsToClosedPromptEvents

  const classes = useChatOptionsStyles()

  const [clickedValue, setClickedValue] = useState(null)

  let is_complete = false
  if (conversation_event) {
    is_complete = promptsToClosedPromptEvents[conversation_event.id]
  }

  if (clickedValue || is_complete) {
    // Right now we only want to display the options if it hasn't been picked because
    // the picked option will be an event with a "chat" kind.
    return (<></>)
  }

  // Only render a single item if it is selected.
  const render_options = options

  return (
    <div className={classes.list}>
      {render_options.map(option => {
        return (
          <Button
            key={option.value}
            id='button'
            onClick={() => {
              setClickedValue(option.value)
              chooseValue(option.value, conversation_event, options)
            }}
            color='secondary'
            variant='outlined'
            className={classes.option}
          >
            {option.label}
          </Button>
        )
      })}
    </div>
  )
}

export default ChatOptionsPicker
